(function () {
  function initDisclosure(disclosureEl) {
    var toggle = disclosureEl.querySelector('[data-disclosure-toggle]');
    var list = disclosureEl.querySelector('[data-disclosure-list]');
    var input = disclosureEl.querySelector('[data-disclosure-input]');
    var options = disclosureEl.querySelectorAll('[data-disclosure-option]');

    if (!toggle || !list) return;

    function close() {
      list.classList.remove('disclosure-list--visible');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function open() {
      list.classList.add('disclosure-list--visible');
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (list.classList.contains('disclosure-list--visible')) {
        close();
      } else {
        open();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        if (input) {
          input.value = option.getAttribute('data-value');
          var form = input.closest('form');
          if (form) form.submit();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!disclosureEl.contains(e.target)) close();
    });
  }

  function initFooter() {
    var disclosures = document.querySelectorAll('[data-disclosure-country], [data-disclosure-locale]');
    disclosures.forEach(initDisclosure);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
  } else {
    initFooter();
  }
})();
